
import { Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { BusqProducto, HttpPaginacionBusqueda } from 'src/app/models/http-paginacion-busqueda.interface';
import { Paginar } from 'src/app/models/http-paginacion.interface';
//import { InformeProductoHospital } from 'src/app/models/informe-producto-hospital';
import { AdministradorService } from 'src/app/services/administrador.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-administrador-productos',
  templateUrl: './administrador-productos.component.html',
  styleUrls: ['./administrador-productos.component.scss']
})
export class AdministradorProductosComponent {
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 10;
  busquedaForm!: FormGroup;
  productosPageInformacion: HttpPaginacionBusqueda<BusqProducto> | undefined;
  productosPage: BusqProducto[] = [];

  constructor(private administradorService: AdministradorService, private messageService: MessageService, private fb: FormBuilder) {
    this.busquedaForm = this.crearFormBusqueda();
    this.obtenerInformacion(1);
  }

  crearFormBusqueda(): FormGroup {
    return this.fb.group({
      codigo: [''],
      nombre_producto: [''],
      lote: [''],
      nombre_hospital: [''],
      serie: [''],
    });
  }
  obtenerInformacion(page: number): void {
    const busqueda = this.busquedaForm.value;

    this.administradorService.buscarProductos(busqueda, page)
      .subscribe({
        next: (resp) => {
          this.productosPageInformacion = resp;
          this.productosPage = resp.data;

          this.first = (resp.current_page - 1) * resp.per_page;
          this.rows = resp.per_page;
          this.totalRecords = resp.total;
        },
        error: (err) => console.log(err)
      })
  }
  onSubmit(): void {
    this.obtenerInformacion(1);
  }
  onPageChange(event: any) {
    const paginar: Paginar = <Paginar>event;
    const paginaActual = paginar.page + 1;
    this.obtenerInformacion(paginaActual);

  }
  exportExcelBack(): void {
    const url = environment.urlBackPublic + environment.xlsxs.datosGeneralesProductos;
    window.open(url, "_blank");
  }
  exportProductosHospital(): void {
    this.administradorService
      .informeProductosHospitales()
      .subscribe({
        next: (resp) => {
          this.exportExcel(resp.datos, "Producto por Hospital ", "producto-hospital");
          this.showSuccess(resp.mensaje);
        },
        error: (err: HttpErrorResponse) => { console.log(err.error.message) }
      })
  }
  exportProductosInstitucion(): void {
    this.administradorService
      .informeProductosInstituciones()
      .subscribe({
        next: (resp) => {
          this.exportExcel(resp.datos, "Producto por Institucion ", "producto-institucion");
          this.showSuccess(resp.mensaje)
        },
        error: (err: HttpErrorResponse) => { console.log(err.error.message) }
      })
  }
  exportProductosCuerpo(): void {
    this.administradorService
      .informeProductosCuerpo()
      .subscribe({
        next: (resp) => {
          this.exportExcel(resp.datos, "Producto por parte cuerpo ", "producto-cuerpo");
          this.showSuccess(resp.mensaje);
        },
        error: (err: HttpErrorResponse) => { console.log(err.error.message) }
      })
  }
  exportExcel(rows: any, encabezado: string, nomArchivo: string): void {
    const EXCEL_EXTENSION = '.xlsx';
    // const saldosEnfermeras: InformeProductoHospital[] = rows;
    const titulo = [{ campo: encabezado, fecha: new Date().toLocaleDateString() }];
    const fileName = nomArchivo;

    import('xlsx').then((XLSX) => {
      const ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_json(ws, titulo, { origin: "A2", skipHeader: true });
      XLSX.utils.sheet_add_json(ws, rows, { origin: "A4" });
      /* generate workbook and add the worksheet */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, nomArchivo);
      /* save to file */

      XLSX.writeFile(wb, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }

  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }

}
